<template>
  <div class="portal-shell" :class="{ 'portal-shell--home': isHome }">
    <portal-header
      :is-home="isHome"
      :nav-items="navItems"
      :session="session"
      @logout="handleLogout"
    />
    <main class="portal-main" :class="{ 'portal-main--home': isHome }">
      <div class="portal-main__inner">
        <router-view />
      </div>
    </main>
    <portal-footer :is-home="isHome" />
  </div>
</template>

<script>
import PortalHeader from '@/components/PortalHeader.vue'
import PortalFooter from '@/components/PortalFooter.vue'
import { clearScopedSession, getAuthEventName, getScopedSession } from '@/utils/auth'

export default {
  name: 'PortalLayout',
  components: {
    PortalHeader,
    PortalFooter
  },
  data() {
    return {
      session: null
    }
  },
  watch: {
    $route() {
      this.syncSession()
    }
  },
  computed: {
    isHome() {
      return this.$route && this.$route.path === '/'
    },
    authScope() {
      return this.$route && this.$route.meta && this.$route.meta.authScope
        ? this.$route.meta.authScope
        : (this.$route && this.$route.path && this.$route.path.startsWith('/post-ability') ? 'postAbility' : 'default')
    },
    navItems() {
      return [
        { label: '首页', to: '/' },
        { label: '成绩列表', to: '/scores' },
        { label: '证书直查', to: '/certificate/ZY20260001' }
      ]
    }
  },
  created() {
    this.syncSession()
  },
  mounted() {
    window.addEventListener(getAuthEventName(), this.syncSession)
  },
  beforeDestroy() {
    window.removeEventListener(getAuthEventName(), this.syncSession)
  },
  methods: {
    syncSession() {
      this.session = getScopedSession(this.authScope)
    },
    handleLogout() {
      clearScopedSession(this.authScope)
      const homePath = this.authScope === 'postAbility' ? '/post-ability' : '/'
      if (this.$route.path !== homePath) {
        this.$router.push(homePath)
      } else {
        this.syncSession()
      }
    }
  }
}
</script>
